"use client";

import type { ReactNode } from "react";
import { useState } from "react";
import ArrowIcon from "@/components/icons/arrow";
import Typography from "@/components/ui/typography";

const CARD_WIDTH = 320;
const GAP = 16;

export const RecommendedVideosCarousel = ({
  children,
  count,
}: {
  children: ReactNode;
  count: number;
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const translateX = -currentIndex * (CARD_WIDTH + GAP);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between items-center">
        <Typography variant="sh2">Önerilen Videolar</Typography>
        <div className="flex gap-2">
          <button
            className="w-10 h-10 rounded-full bg-white flex items-center justify-center disabled:opacity-30 cursor-pointer disabled:cursor-default transition-opacity"
            disabled={currentIndex === 0}
            onClick={() => setCurrentIndex((i) => Math.max(0, i - 1))}
            type="button"
          >
            <ArrowIcon className="stroke-brand-blue-600 rotate-180" />
          </button>
          <button
            className="w-10 h-10 rounded-full bg-white flex items-center justify-center disabled:opacity-30 cursor-pointer disabled:cursor-default transition-opacity"
            disabled={currentIndex >= count - 1}
            onClick={() => setCurrentIndex((i) => Math.min(count - 1, i + 1))}
            type="button"
          >
            <ArrowIcon className="stroke-brand-blue-600" />
          </button>
        </div>
      </div>
      <div className="overflow-hidden">
        <div
          className="flex transition-transform duration-300 ease-out"
          style={{ gap: GAP, transform: `translateX(${translateX}px)` }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
